module.exports = __webpack_public_path__ + "static/media/ic_claim_assist_myway.156cee0a.svg";